
import {DG_axios} from "../../custom/axios";


const baseURL = `/o/dogoo/report`
export async function getReportNow(weighingStationCode) {
    const response = await DG_axios.get(baseURL + "/now" , {
        params : {
            weighingStationCode
        }
    } )
    return response?.data.result || []
}

export async function getReportCompare(weighingStationCode, startDate, endDate,
                                       startDateCompare, endDateCompare) {
    const response = await DG_axios.get(baseURL + "/compare", {
        params : {
            weighingStationCode,
            startDate,
            endDate,
            startDateCompare,
            endDateCompare
        }
    } )
    return response?.data.result || []
}
export async function getReportChart(weighingStationCode, type, startDate, endDate,
                                       startDateCompare, endDateCompare) {
    const response = await DG_axios.get(baseURL + "/chart", {
        params : {
            weighingStationCode,
            type,
            startDate,
            endDate,
            startDateCompare,
            endDateCompare
        }
    } )
    return response?.data.result || []
}
